/**@flow */
/**
 * Signin Cognito
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { FormGroup, Input, Form } from "reactstrap";
import LinearProgress from "@material-ui/core/LinearProgress";
import QueueAnim from "rc-queue-anim";
import AppConfig from "Constants/AppConfig";
import { signinUserInCognito } from "Actions";
import { errorHandling } from "Helpers/helpers";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { injectIntl } from "react-intl";
const Props = {
  signinUserInCognito: PropTypes.func,
  history: PropTypes.object,
  loading: PropTypes.bool
};

class Signin extends Component<typeof Props, typeof State> {
  constructor(props: typeof Props) {
    super(props);

    this.onUserLogin = this.onUserLogin.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.togglePasswordView = this.togglePasswordView.bind(this);
    this.state = {
      email: "",
      password: "",
      passwordType: "password"
    };
  }
  componentDidMount() {
    const { user } = this.props;
    console.log("COMPONENT DID MOUNT DASHBOARD", user);
    if (user) {
      this.props.history.push("/app/dashboard");
    }
  }
  /**
   * On User Login
   */
  onUserLogin() {
    try {
      if (this.state.email !== "" && this.state.password !== "") {
        this.props.signinUserInCognito(
          { ...this.state, intl: this.props.intl },
          this.props.history
        );
      }
    } catch (error) {
      errorHandling(error);
    }
  }

  onKeyDown(e: Object) {
    if (e.key === "Enter") {
      this.onUserLogin();
    }
  }

  togglePasswordView() {
    let passwordType =
      this.state.passwordType === "password" ? "text" : "password";
    this.setState({ ...this.state, passwordType: passwordType });
  }
  handleEmailLogin(email: String) {
    let e = email;
    e = e.trim();
    e = e.toLowerCase();
    this.setState({ email: e });
  }
  render(): React$Element<any> {
    const { email, password, passwordType } = this.state;
    const { loading } = this.props;
    return (
      <QueueAnim type="bottom" duration={2000}>
        <div className="rct-session-wrapper">
          {loading && <LinearProgress />}
          <div className="session-inner-wrapper">
            <div className="container">
              <div className="row align-items-center h-100">
                <div className="col-12">
                  <div 
                  style={{
                    backgroundColor: "#fa3a12"
                  }}
                  className="session-body text-center mx-auto">
                    <div className="session-head mb-30">
                      <Link to="/">
                        <img
                          src={AppConfig.appLogo}
                          alt="session-logo"
                          className="img-fluid"
                          width="300"
                          height="102"
                          style={{
                            marginBottom: "25px",
                            width: "300px"
                          }}
                        />
                      </Link>
                      <div className="page-title-wrap">
                      <h2
                              id="page-title"
                              className="text-white page-title"
                            >
                              ConnectShip Manager
                            </h2>
                      </div>
                      <p className="mb-0 text-white">
                        We are transforming your freight and logistics
                        experience!
                      </p>
                    </div>
                    <div>
                      <Form>
                        <FormGroup className="has-wrapper">
                          <Input
                            type="email"
                            value={email}
                            name="user-mail"
                            id="user-mail"
                            className="has-input input-lg"
                            placeholder="Username or Email"
                            onChange={(event: Object) => {
                              this.handleEmailLogin(event.target.value);
                            }}
                            onKeyDown={this.onKeyDown}
                          />
                        </FormGroup>
                        <FormGroup className="has-wrapper">
                          <Input
                            value={password}
                            type={passwordType}
                            name="user-pwd"
                            id="pwd"
                            className="has-input input-lg"
                            placeholder="Password"
                            onChange={(event: Object) => {
                              this.setState({ password: event.target.value });
                            }}
                            onKeyDown={this.onKeyDown}
                          />
                          <span className="has-icon">
                            {passwordType === "text" ? (
                              <Visibility onClick={this.togglePasswordView} />
                            ) : (
                              <VisibilityOff
                                onClick={this.togglePasswordView}
                              />
                            )}
                          </span>
                        </FormGroup>
                        <FormGroup className="mb-15">
                          <Button
                            style={{ backgroundColor: "#00469B" }}
                            className="text-white w-100"
                            variant="contained"
                            size="large"
                            onClick={() => {
                              this.onUserLogin();
                            }}
                          >
                            Sign In
                          </Button>
                        </FormGroup>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </QueueAnim>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser }: Object): Object => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    signinUserInCognito
  }
)(injectIntl(Signin));
